// extracted by mini-css-extract-plugin
module.exports = {"serviceAvatar":"ActivityUser_serviceAvatar__2qLV9"};